import {Engine} from "platform/engine/Engine";
import {SetFilterVisible} from "core/redux/filter/FilterReduxActions";
import Platform from "platform/Platform";

export default class FilterEngine extends Engine {

    private static _instance: FilterEngine;

    public static instance(): FilterEngine {
        return this._instance || (this._instance = new this());
    }

    public async setup(): Promise<void> {
        await super.setup();
    }

    public onChangeRoute = (payload): void => {
        Platform.dispatch(SetFilterVisible({visible: false}));
    }
}
